import { UserInfoContext } from "Context/CommonContext";
import { useContext, useEffect, useState } from "react";
import "./index.css";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { BASE_URL, GET_SIGNED_URL } from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { Spinner } from "reactstrap";
import ErrorView from "Pages/AssetView/ErrorView";

interface IAssetInfo {
  courseId?: number | string;
  assetId?: number | string;
  title?: string;
  type?: string;
  desc?: string;
}
const PPTView = ({ assetId, courseId }: IAssetInfo) => {
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const [pptUrl, setPptUrl] = useState<string>("");
  console.log(userInfo, assetId, "scheduleAssetData", pptUrl);
  const { makeRequest: fetchFile, loading } = useGetApi(
    (data: any) => {
      setPptUrl(data?.detailMessage);
      //   setPptUrl(
      //     "https://content-staging-aakash.s3.ap-south-1.amazonaws.com/Media/Faculty_ppt/422937/Travel_Presentation_PP.pptx"
      //   );
    },
    (error: any) => {
      console.error(error);
    }
  );
  useEffect(() => {
    fetchFile(
      BASE_URL + GET_SIGNED_URL + `?assetId=${assetId}&courseId=${courseId}`
    );
  }, [assetId]);
  return (
    <div className="assetPPTView">
      {loading ? (
        <Spinner color="info" />
      ) : !loading && pptUrl && pptUrl != "" ? (
        <>
          <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
              pptUrl
            )}`}
            width="100%"
            height="100%"
            frameBorder="0"
            title="PowerPoint viewer"
          ></iframe>
          {/* <iframe
            src={`//docs.google.com/gview?url=${pptUrl}&embedded=true`}
            width="100%"
            height="470px"
            frameBorder="0"
          ></iframe> */}
        </>
      ) : (
        <ErrorView />
      )}
    </div>
  );
};

export default PPTView;
